<template lang="pug">
.card.mb-0(v-if="!isOperator")
  .card-header
    .row.w-100
      .form-group.col-md-5.col-4.mb-1(v-if="[5,4,3].includes(accountType)")
        b-input-group(size="sm")
          b-form-select.col-4(v-model="searchType" size="sm" @change="initSearchData()")
            option(value="domain_name") {{ $t('ui.domain_name') }}
            option(value="domain_status") {{ $t('ui.domain_status') }}
            option(value="domain_group") {{ $t('ui.domain_group') }}
          template(v-if="['domain_name'].includes(searchType)")
            DebounceInput(autofocus type="text" v-model="searchData" :placeholder="$t('message.search_by_' + searchType)" @enter="getDomainMasterList(true)" size="sm")
          template(v-else-if="['domain_group'].includes(searchType)")
            b-form-select.col-4(v-model="domainGroup" size="sm" @change="getDomainMasterList(true)")
              option(value="") {{ $t('ui.all') }}
              option(value="MEMBER") {{ $t('ui.member') }}
              option(value="AFFILIATE") {{ $t('ui.affiliate') }}
              option(value="OPERATOR") {{ $t('ui.operator') }}
          template(v-else)
            b-form-select.col-4(v-model="domainStatus" size="sm" @change="getDomainMasterList(true)")
              option(value="") {{ $t('ui.all') }}
              option(value="ACTIVE") {{ $t('ui.active') }}
              option(value="DEACTIVATE") {{ $t('ui.deactivate') }}
      .form-group.col-6.mb-1(v-if="['domain_name'].includes(searchType)")
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getDomainMasterList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-12(v-if="isAdmin")
        template(v-if="isEditAccess")
          b-button(v-b-modal.addDomainBatch type="button" variant="warning" size="sm")
            i.fa.fa-plus
            span.ml-1 {{ $t("ui.combine.add_domain_batch") }}

  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="4%")
                  span #
                th(width="15%" @click="sortOrder('domain_name')")
                  span(:title="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
                  .float-right
                    i(:class="changeSortKey('domain_name')")
                th(width="10%" @click="sortOrder('domain_type')")
                  span(:title="$t('ui.domain_type')") {{ $t('ui.domain_type') }}
                  .float-right
                    i(:class="changeSortKey('domain_type')")
                th.text-center(width="10%" @click="sortOrder('domain_group')")
                  span(:title="$t('ui.domain_group')") {{ $t("ui.domain_group") }}
                  .float-right
                    i(:class="changeSortKey('domain_group')")                        
                th.text-center(width="6%" @click="sortOrder('status')")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                  .float-right
                    i(:class="changeSortKey('status')")
                th(width="10%")
                  span(:title="$t('ui.operator_id')") {{ $t("ui.operator_id") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.price')") {{ $t("ui.price") }}
                th.text-right(width="10%" @click="sortOrder('created_date')")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  i(:class="changeSortKey('created_date')")
                th.text-right(width="10%")
                  span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
            tbody.clusterize-content
              tr(v-if="domainList.length == 0")
                td(colspan="10").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in domainList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.domain_name")
                    a.text-decoration-none(href="javascript:void(0)" @click="openNewTab(item)") {{ item.domain_name }} 
                td
                  span(:title="item.domain_type") {{ item.domain_type }}
                td.text-center
                  span(:title="item.domain_group") {{ item.domain_group }}                                                
                td.text-center
                  template(v-if="isEditAccess")
                    b-link(href="javascript:void(0)" @click="isAdmin ? domainStatusUpdate(item) : null" :title="item.status")
                      i(:class="{ 'fas fa-check text-success': item.status == 'ACTIVE', 'fas fa-times text-warning': item.status == 'DEACTIVATE'}")
                  template(v-else)
                    span(:title="item.status")
                      i(:class="{ 'fas fa-check text-success': item.status == 'ACTIVE', 'fas fa-times text-warning': item.status == 'DEACTIVATE'}") 
                td
                  span(:title="item.operator_id") {{ item.operator_id }}
                td.text-right
                  span(:title="$n(item.price, 'currency')") {{ item.price ? $n(item.price, 'currency') : "-" }}  
                td.text-right
                  span(:title="item.created_by") {{ item.created_by }}
                  br
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  span(:title="item.modified_by") {{ item.modified_by ? item.modified_by : "-" }}
                  br
                  span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ item.modified_date ? $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') : "-" }}

  adddomainbatch(@clicked="addDomainBatch" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import adddomainbatch from "@/components/domain/addDomainBatch.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    adddomainbatch
  },
  data: () => ({
    loading: false,
    domainList: [],
    currentPage: 1,
    totalRow: 0,
    searchType: "domain_name",
    searchData: null,
    domainGroup: "",
    domainStatus: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "domain_name",
    sortType: "asc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_domainlist");
    }
  },
  mounted: function() {
    this.getDomainMasterList(true);
  },
  methods: {
    openNewTab(obj) {
      const url = obj.domain_name.startsWith('http') ? obj.domain_name : `https://${obj.domain_name}`;
      window.open(url, '_blank', "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=250,width=1500,height=800");
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getDomainMasterList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getDomainMasterList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getDomainMasterList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    initSearchData() {
      if(['domain_name'].includes(this.searchType)) {
        this.searchData = null;
      } else {
        this.domainStatus = "";
      }

      this.getDomainMasterList(true)
    },
    getDomainMasterList: function(isSearch, evt) {
      let url = config.domainMasterListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.searchType == 'domain_name')
        json.domain_name = this.searchData;

      if (this.searchType == 'domain_group'){
        if (this.domainGroup.trim() != '') {
          json.module = this.domainGroup;
        }
      }

      if (this.searchType == 'domain_status'){
        if (this.domainStatus.trim() != '') {
          json.domain_status = this.domainStatus;
        }
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.domainList = response.data.dt;
                this.totalRow = this.domainList.length > 0 ? this.domainList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    domainStatusUpdate: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.domain_status_update_confirm", { name: item.domain_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDomainStatusUpdate(item);
          } else {
            this.getDomainMasterList();
          }
        });
    },
    confirmDomainStatusUpdate: function(item) {
      let url = config.domainStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        domain_id: item.domain_id,
        domain_status: item.status == 'ACTIVE' ? 'DEACTIVATE' : "ACTIVE",
      };

      this.feedback.success = true;
      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                // console.log(this.$helpers.handleFeedback(this.feedback.status))
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getDomainMasterList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addDomainBatch: function(response) {
      this.searchType = "domain_name";
      this.searchData = null;
      this.domainStatus = "";
      this.getDomainMasterList(true);

      if(response.dt.length > 0) {
        let htmlStart = "<div class='small table-responsive'><table class='table table-sm table-bordered'>"
        let htmlHeader = "<thead class='thead-dark'><tr><th class='w-50'>" + this.$t("ui." + Object.keys(response.dt[0])[0]) + "</th><th class='w-50'>" + this.$t("ui." + Object.keys(response.dt[0])[1]) + "</th></tr></thead><tbody>"
        let htmlBody = ""
        let htmlEnd = "</tbody></table></div>"

        for(var i = 0; i < response.dt.length; i++) {
          htmlBody += "<tr><td>" + response.dt[i].domain_name + "</td><td>" + this.$t("error." + response.dt[i].status) + "</td></tr>"
        }

        this.$swal({
          title: this.$t("ui.combine.add_domain_batch"),
          html: htmlStart  + htmlHeader + htmlBody + htmlEnd,
          type: "success",
          allowOutsideClick: false
        }).then(isConfirm => {
          if (isConfirm) {
            
          }
        });
      } else {
        this.$helpers.showDialog(this.$t("ui.combine.add_domain_batch"), this.$t("message.success"), "success");
      }
    }
  }
};
</script>